import "./App.css"
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import ScholarLogin from "./pages/ScholarLogin"
import ScholarOTP from "./pages/ScholarOTP"
import ScholarAcknowledgementReceipt from "./pages/ScholarAcknowledgementReceipt"
import ScholarLogout from "./pages/ScholarLogout"
import ScholarAcknowledgementDetails from "./pages/ScholarAcknowledgementDetails"
import ScholarAcknowledgementConfirmation from "./pages/ScholarAcknowledgementConfirmation"
import ScholarProfileManagement from "./pages/ScholarProfileManagement"
import AdminLogin from "./pages/AdminLogin"
import AdminAcknowledgementReceipt from "./pages/AdminAcknowledgementReceipt"
import AdminLogout from "./pages/AdminLogout"
import AdminScholarManagement from "./pages/AdminScholarManagement"
import AdminReports from "./pages/AdminReports"
import 'antd/dist/reset.css';

// importing css
import "./styles/ScholarLogin.css"
import "./styles/ScholarOTP.css"
import "./styles/ScholarAcknowledgementReceipt.css"
import "./styles/ScholarLogout.css"
import "./styles/AdminLogin.css"
import "./styles/AdminAcknowledgementReceipt.css"
import "./styles/AdminSidebar.css"
import "./styles/AdminLogout.css"
import "./styles/ScholarAcknowledgementConfirmation.css"
import "./styles/AdminScholarManagement.css"

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/scholar-login" component={ScholarLogin} />
          <Route path="/scholar-otp" component={ScholarOTP} />
          <Route path="/scholar-acknowledgement-receipt" component={ScholarAcknowledgementReceipt} />
          <Route path="/scholar-acknowledgement-details/:id" component={ScholarAcknowledgementDetails} />
          <Route path="/scholar-acknowledgement-confirmation" component={ScholarAcknowledgementConfirmation} />
          <Route path="/scholar-profile" component={ScholarProfileManagement} />
          <Route path="/scholar-logout" component={ScholarLogout} />
          <Route path="/admin-login" component={AdminLogin} />
          <Route path="/admin-acknowledgment-receipt" component={AdminAcknowledgementReceipt} />
          <Route path="/admin-scholar-management" component={AdminScholarManagement} />
          <Route path="/admin-report" component={AdminReports} />
          <Route path="/admin-logout" component={AdminLogout} />
          {/* Redirect from / to /scholar-login */}
          <Route exact path="/">
            <Redirect to="/scholar-login" />
          </Route>
          {/* Catch all other routes and redirect to login */}
          <Route path="*">
            <Redirect to="/scholar-login" />
          </Route>
        </Switch>
      </Router>
    </div>
  )
}

export default App;
